import { BaseModel, attr, belongsTo, hasMany } from "../../lib/itn-ui-kit/data";

export default class ProviderModel extends BaseModel {
  static urlPath = "provider";

  @attr("number") pk;
  @attr("string") name;
  @attr("string") phone;
  @attr("string") schedule;
  @attr("boolean") inNetwork;
  @attr("array") providerTypes;
  @attr("string") createdByName;
  @attr("json") managedBy;
  @attr("boolean") receivingClients;
  @attr("boolean") acceptsFunding;
  @attr("datetime") createdAt;
  @attr("datetime") updatedAt;
  @attr("string") rating;
  @attr("string") distance;
  @attr("boolean") advertising;
  @attr("boolean") favorite;
  @belongsTo("address") address;
  @attr("string") email;
  @attr("number") communicationPreference;
  @attr("string") notes;
  @attr("string") homepage;
  @attr("json") entity;
  @attr("json") parent;
  @attr("string") employerIdentificationNumber;
  @attr("string") npi;
  @attr("string") nps;
  @attr("string") startDate;
  @attr("string") termDate;
  @attr("string") emrUrl;
  @attr("string") emrSystem;
  @attr("number") activeState;
  @attr("string") activeStateName;
  @hasMany("provider-email") emails;
  @hasMany("contact-info") contactInfos;
  @hasMany("provider-office-hours") officeHours;
  @attr("json") providerType;
  @attr("string") key;
  @attr("string") value;
  @attr("string") label;
}
